import { useMemo } from "react";
import { useClasses } from "@api/class.api";
import { useIsAccrualLedgerEnabled } from "@hooks/useIsAccrualLedgerEnabled";
import { FilterTabs } from "@components/pageHeader/filters/lib";

/**
 * Full set of transactions-page filters for the accrual review task,
 * feature-flag gated. Ordered to match TransactionsPage.
 */
export const useAccrualReviewAvailableFilters = () => {
    const { isActivated: classesEnabled } = useClasses();
    const isAccrualLedgerFilterEnabled = useIsAccrualLedgerEnabled();

    return useMemo(
        () => [
            FilterTabs.DATE,
            FilterTabs.CATEGORY,
            FilterTabs.ACCOUNT,
            ...(classesEnabled ? [FilterTabs.CLASS] : []),
            FilterTabs.AMOUNT,
            FilterTabs.RULES,
            FilterTabs.COUNTERPARTY,
            FilterTabs.NOTE,
            FilterTabs.RECEIPTS,
            FilterTabs.SPLIT,
            FilterTabs.RECONCILIATION,
            FilterTabs.MATCHED,
            FilterTabs.LEDGER,
            ...(isAccrualLedgerFilterEnabled
                ? [FilterTabs.ACCRUAL_LEDGER]
                : []),
            FilterTabs.TRANSACTION_LOCKED,
        ],
        [classesEnabled, isAccrualLedgerFilterEnabled],
    );
};
